import { initBlazeSliders } from '../common/blaze-slider/blaze-slider-loader.js';
import { initContentGalleries } from './gallery/gallery.js';
import { initContentImageSliders } from './image-slider/image-slider.js';
import { initContentVideos } from './video/video.js';
import { initMediaLibraries } from '../common/media-library/media-library.js';

/** Shared enhancements for explicitly opted-in content pages and previews. */
export function initContentComponents(root = document) {
    // These components can stack inside a sidebar/column independently of the
    // viewport. Old saved HTML still has half-viewport image hints; use a safe
    // full-viewport upper bound without measuring layout or changing the model.
    root.querySelectorAll(
        '.z-content :is(.z-image-text, .z-harvest-feature, .z-image-text-card) img[srcset]',
    ).forEach((image) => {
        image.sizes = '100vw';
        image
            .closest('picture')
            ?.querySelectorAll('source[srcset]')
            .forEach((source) => {
                source.sizes = '100vw';
            });
    });
    initContentGalleries(root);
    initContentImageSliders(root);
    initContentVideos(root);
    initMediaLibraries(root);
    initBlazeSliders(root);
}
